import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translations
// FLOW[24124]: MS204 - Added admin namespace for Admin Dashboard translations
import ruCommon from './locales/ru/common.json';
import ruAuth from './locales/ru/auth.json';
import ruProduction from './locales/ru/production.json';
import ruPartner from './locales/ru/partner.json';
import ruOrders from './locales/ru/orders.json';
import ruDocuments from './locales/ru/documents.json';
import ruAdmin from './locales/ru/admin.json';
import ruPrepress from './locales/ru/prepress.json';

import enCommon from './locales/en/common.json';
import enAuth from './locales/en/auth.json';
import enProduction from './locales/en/production.json';
import enPartner from './locales/en/partner.json';
import enOrders from './locales/en/orders.json';
import enDocuments from './locales/en/documents.json';
import enAdmin from './locales/en/admin.json';
import enPrepress from './locales/en/prepress.json';

const resources = {
  ru: {
    common: ruCommon,
    auth: ruAuth,
    production: ruProduction,
    partner: ruPartner,
    orders: ruOrders,
    documents: ruDocuments,
    admin: ruAdmin,
    prepress: ruPrepress,
  },
  en: {
    common: enCommon,
    auth: enAuth,
    production: enProduction,
    partner: enPartner,
    orders: enOrders,
    documents: enDocuments,
    admin: enAdmin,
    prepress: enPrepress,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'ru',
    defaultNS: 'common',
    ns: ['common', 'auth', 'production', 'partner', 'orders', 'documents', 'admin', 'prepress'],

    interpolation: {
      escapeValue: false, // React already escapes
    },

    detection: {
      // Russian is the product's primary language: an explicit choice stored
      // in localStorage wins, everything else gets ru (fallbackLng). Browser
      // language detection used to flip fresh devices to English.
      order: ['localStorage'],
      caches: ['localStorage'],
    },
  });

export default i18n;
